import { WorkspaceRateLimit, useWorkspaceRateLimitsQuery } from '@/types/generated/graphql';
import { AppAlert } from '@components/antd';
import UsageLimitModal from '@components/rate-limit/usage-limit.modal';
import { cacheOnly } from '@shared/constants';
import { capitalizeFirst } from '@shared/utils/capitalize';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function RateLimitBanner() {
  const [openModal, setOpenModal] = useState(false);
  const { data } = useWorkspaceRateLimitsQuery(cacheOnly);
  const { t } = useTranslation();
  const limitParser = useMemo(
    () =>
      (data?.workspaceRateLimits?.data as WorkspaceRateLimit[])?.reduce((acc: string[], curr: WorkspaceRateLimit) => {
        const hasMaxed = curr?.exhaust?.value === curr?.threshold;

        if (!hasMaxed) return acc;

        if (curr?.category === 'message') return [...acc, 'incoming message'];
        if (curr?.direction === 'outgoing') return [...acc, 'outgoing call'];
        if (curr?.direction === 'incoming') return [...acc, 'incoming call'];

        return acc;
      }, []),
    [data]
  );

  return (
    <>
      <AppAlert
        showIcon
        type="error"
        message={
          <p className="h-20 overflow-auto md:h-[unset]">
            {t(
              'ready_for_more_it_looks_like_youve_hit_daily_limit_unlock_unlimited_conversations_by_verifying_your_identity',
              { limit: limitParser?.join() }
            )}
            <span className="ml-1 cursor-pointer text-amber-700" onClick={() => setOpenModal(true)}>
              {capitalizeFirst(t('check_my_status'))}
            </span>
          </p>
        }
      />
      <UsageLimitModal open={openModal} closeModal={() => setOpenModal(false)} />
    </>
  );
}
